import { isMobileOnly } from 'react-device-detect';

export const isSmartPhoneBrowser = () => isMobileOnly;
